import { instance } from "../API/Axios";

export const GetReports = async (SubscriberId, FromDate, ToDate) =>{
    try{
        const response = await instance.get("getReports", {
            params : {
                SubscriberId : SubscriberId,
                FromDate : FromDate,
                ToDate : ToDate
            }
        });
        return response.data;
    }
   catch(ex){
    throw ("Exception Occured "+ex)
   }
}